module.exports = __webpack_public_path__ + "static/media/background-pc.2b752ffc.png";